// extracted by mini-css-extract-plugin
export default {"newTask":"Form_newTask__9Umal","inputContainer":"Form_inputContainer__70GgF"};